import script from "./Table4WorkspaceSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./Table4WorkspaceSearch.vue?vue&type=script&setup=true&lang=js"

import "./Table4WorkspaceSearch.vue?vue&type=style&index=0&id=34108c70&lang=scss&scoped=true"
import "./Table4WorkspaceSearch.vue?vue&type=style&index=1&id=34108c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34108c70"]])

export default __exports__